import React from 'react';
import PropTypes from 'prop-types';
import TextareaAutosize from 'react-textarea-autosize';
import { isNull } from 'lodash';

const FormikTextInput = ({
  disabled,
  name,
  value,
  onBlur,
  onChange,
  onKeyPress,
  maxLength,
}) => (maxLength < 200
  ? (
    <div className="input-group">
      {name.includes('URL') && (<div className="input-group-prepend"><span className="input-group-text"><i className="far fa-link" /></span></div>)}
      <input
        type="text"
        id={name}
        autoComplete="off"
        disabled={disabled}
        value={value ?? ''}
        onBlur={onBlur}
        onChange={onChange}
        onKeyPress={onKeyPress}
        maxLength={maxLength}
        name={name}
        className="form-control text-input"
      />
      {(!disabled && maxLength > 50) && (
        <div className="input-group-append">
          <div className="input-group-text">
            {maxLength > 0 && !disabled ? `${isNull(value) ? 0 : value.length} / ${maxLength}` : null}
          </div>
        </div>
      )}
    </div>
  )
  : (
    <div className="input-group">
      {name.includes('URL') && (<div className="input-group-prepend"><span className="input-group-text"><i className="far fa-link" /></span></div>)}
      <TextareaAutosize
        type="text"
        id={name}
        name={name}
        className="form-control text-input"
        value={value ?? ''} // Do not remove, otherwise it throws an uncontrolled component error
        onBlur={onBlur}
        onChange={onChange}
        onKeyPress={onKeyPress}
        maxLength={maxLength}
        autoComplete="off"
        maxRows={4}
        disabled={disabled}
      />
      {(!disabled && maxLength > 50) && (
      <div className="input-group-append">
        <div className="input-group-text">
          {maxLength > 0 && !disabled ? `${isNull(value) ? 0 : value.length} / ${maxLength}` : null}
        </div>
      </div>
      )}
    </div>
  )
);

FormikTextInput.propTypes = {
  disabled: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool, PropTypes.instanceOf(null)]), // if value is null
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onKeyPress: PropTypes.func,
  maxLength: PropTypes.number,
};

export default FormikTextInput;
